<img pTooltip="{{ getStatusLabel() }}" [src]="getImageSrc()" alt="Chip Image" />
